import React from "react";
import { IUser } from "../../../types/user";

interface Props {
  profile: IUser;
}

const UserDescription = ({ profile }: Props) => {
  return (
    <>
      <div className="text-muted mb-4">
        <p>{profile.enterprise ?? "-"}</p>
      </div>

      <div>

        <div className="d-flex py-2">
          <i className="bx bx-user me-3 text-muted"></i>
          <p className="mb-0">{profile.name}</p>
        </div>

        <div className="d-flex py-2">
          <i className="bx bx-message-rounded-dots me-3 text-muted"></i>
          <p className="mb-0">{profile.email}</p>
        </div>

        <div className="d-flex py-2">
          <i className="bx bx-check-circle me-3 text-muted"></i>
          <p className="mb-0">{profile.isActive ? "Ativo" : "Inativo"}</p>
        </div>

      </div>
    </>
  );
};

export default UserDescription;
